import styled from 'styled-components';

import { BREAK_POINTS } from '../../../../../consts/styleDedupe';
import { Orange } from '../../../../../consts/variantStyles';

export const Card = styled.div`
  background-color: #ffffff;
  padding: 24px 16px;
  box-sizing: border-box;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 24px 32px;
    margin: 32px 0;
    width: 342px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    padding: 32px 32px;
    width: 462px;
  }
`;

export const TransparentCard = styled.div`
  box-sizing: border-box;
  margin: 0;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    width: 342px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    width: 396px;
  }

  // update input
  & input {
    color: white;
    background-color: transparent;
    border-bottom-width: 1px;
    margin: 0 auto;
    text-align: center;

    &:focus,
    &:active {
      color: white;
    }
    &::placeholder {
      color: #fb815f;
    }

    @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
      margin: 0;
      text-align: left;
    }
  }

  //update faux button
  & [data-id*='banner-'] {
    ${Orange.button}
    width: 15rem;

    & span {
      font-size: 16px;
    }

    &:hover:not(:disabled),
    &:active:not(:disabled) {
      ${Orange.buttonHover}
    }
  }
`;

export const HeadingContainer = styled.div`
  margin-bottom: 16px;
  h1 {
    margin-top: 0;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    margin-bottom: 24px;
  }
`;

export const PostcodeInputContainer = styled.div`
  display: block;
  margin: 0 auto 24px;

  width: 15rem;
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    width: inital;
    margin: 0 0 24px;
  }
`;
